import React, { useEffect, useState, useMemo } from "react";
import {
  Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, ModalFooter,
  Label, Input, Badge, Spinner, Button, UncontrolledTooltip,
  Nav, NavItem, NavLink, TabContent, TabPane,
  InputGroup, InputGroupText
} from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import HizliHakModal from "./HizliHakModal";
import KozmetikHakModal from "./KozmetikHakModal";
import TopluHakModal from "./TopluHakModal";
import { getAuthHeaders } from "../../../helpers/apiConfig";

// Sosyal giriş (api/auth/social/admin) — KULLANICI_SOSYAL_HESAPLAR, EDMX'te yok.
const SAGLAYICI_BILGI = {
  google: { ad: "Google", ikon: "bx bxl-google", renk: "#DB4437" },
  apple: { ad: "Apple", ikon: "bx bxl-apple", renk: "#000000" },
  facebook: { ad: "Facebook", ikon: "bx bxl-facebook-circle", renk: "#1877F2" },
};

const KullaniciListesi = () => {
  document.title = "Kullanıcı Listesi | HarmanaGEL Admin";

  const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // ─── FİLTRELER ───────────────────────────────────────────────
  const [searchQuery, setSearchQuery] = useState("");
  const [filterRol, setFilterRol] = useState("all");
  const [filterDurum, setFilterDurum] = useState("all");
  const [filterGiris, setFilterGiris] = useState("all"); // all | google | apple | facebook | telefon
  // KULLANICI_ID → [{ ID, SAGLAYICI, EPOSTA, OLUSTURMA_TARIHI, SON_GIRIS_TARIHI }]
  const [sosyalHaritasi, setSosyalHaritasi] = useState({});
  const [dateStart, setDateStart] = useState("");   // yyyy-mm-dd
  const [dateEnd, setDateEnd] = useState("");        // yyyy-mm-dd
  const [datePreset, setDatePreset] = useState("all"); // hızlı aralık seçimi

  // Modal State'leri
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false); // Ekleme mi Düzenleme mi?

  const [activeViewTab, setActiveViewTab] = useState("1");
  const [activeEditTab, setActiveEditTab] = useState("1"); // Düzenleme Modalı Sekmeleri
  
  const [selectedUser, setSelectedUser] = useState(null); // Düzenleme/Ekleme için state
  const [detailedUser, setDetailedUser] = useState(null); // Görüntüleme için state
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Şifre görünürlüğü

  // Kategori bazlı hakları listeden çıkmadan verebilmek için (ayrı sayfaya gitmeye gerek yok)
  const [hakModal, setHakModal] = useState(false);
  const [hakUser, setHakUser] = useState(null);

  // Kozmetik/ekstra haklar (vitrin, moderatör, mezat deneme…) + hak geçmişi
  const [kozmetikModal, setKozmetikModal] = useState(false);
  const [kozmetikUser, setKozmetikUser] = useState(null);

  // Toplu hak verme için seçim
  const [seciliIdler, setSeciliIdler] = useState([]);
  const [topluModal, setTopluModal] = useState(false);

const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';
  
  // EKSİK OLAN KISIM BURASI 👇
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = useMemo(() => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  }), [token]);
  // 👆 

  useEffect(() => {
    if (isAdmin) fetchUsers();
  }, [isAdmin]);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/KULLANICILAR?$orderby=ID desc`);
      const result = await response.json();
      setUsers(result.value || []);
      fetchSosyalHesaplar();
    } catch (error) {
      toast.error("Kullanıcılar yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  // Sosyal hesap bağlantıları ayrı uçtan gelir; uç henüz yayında değilse
  // (404) liste yine çalışır, sütun herkes için "Telefon" görünür.
  const fetchSosyalHesaplar = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/auth/social/admin`, { headers: getAuthHeaders() });
      if (!res.ok) return;
      const satirlar = await res.json();
      const harita = {};
      (Array.isArray(satirlar) ? satirlar : []).forEach((r) => {
        (harita[r.KULLANICI_ID] = harita[r.KULLANICI_ID] || []).push(r);
      });
      setSosyalHaritasi(harita);
    } catch (e) {
      /* sosyal veri opsiyonel */
    }
  };

  const sosyalBaglantiKaldir = async (baglanti) => {
    const ad = SAGLAYICI_BILGI[baglanti.SAGLAYICI]?.ad || baglanti.SAGLAYICI;
    if (!window.confirm(`${ad} bağlantısını kaldırmak istediğinize emin misiniz? Kullanıcı silinmez; ${ad} ile tekrar girerse yeniden eşleştirilir.`)) return;
    try {
      const res = await fetch(`${BASE_URL}/api/auth/social/admin/${baglanti.ID}`, { method: "DELETE", headers: getAuthHeaders() });
      if (!res.ok) throw new Error();
      toast.success(`${ad} bağlantısı kaldırıldı.`);
      fetchSosyalHesaplar();
    } catch (e) {
      toast.error("Bağlantı kaldırılamadı.");
    }
  };

  // --- YENİ KULLANICI EKLEME MODALI AÇILIŞI ---
// --- YENİ KULLANICI EKLEME MODALI AÇILIŞI ---
  const handleAddProfile = () => {
    setIsAddMode(true);
    setSelectedUser({
      ID: null, AD_SOYAD: "", Mail_Adress: "", CEP_NO: "", AKTIF_DURUM: true,
      Password: "",
      Address_ID: null, City: "", District: "", AddressText: "",
      Company_ID: null, Company_Name: "",
      Invoice_ID: null, Bank_ID: null, Tax_No: "", Tax_Office: "", IBAN: "", Bank_Name: "",
      Haklar_ID: null, ILAN_HAKKI: 2, MEZAT_HAKKI: 0, DEGERLEME_HAKKI: 0
    });
    setActiveEditTab("1");
    setEditModal(true);
  };

  // --- KATEGORİ BAZLI HAK MODALI ---
  // Sadece setter kullanır; columns useMemo([]) içinden çağrıldığı için
  // referansının render'lar arası değişmemesi önemli.
  const openHakModal = (user) => {
    setHakUser(user);
    setHakModal(true);
  };

  const openKozmetikModal = (user) => {
    setKozmetikUser(user);
    setKozmetikModal(true);
  };

  // --- DÜZENLEME MODALI AÇILIŞI (TÜM VERİLERİ ÇEK) ---
  const handleEditProfile = async (user) => {
    setIsAddMode(false);
    setEditModal(true);
    setIsDetailsLoading(true);
    setActiveEditTab("1");
    try {
      const response = await fetch(
        `${BASE_URL}/KULLANICILAR?$filter=ID eq ${user.ID}&$expand=KULLANICI_ADRESLERI,FATURA_BILGILERI,MAGAZALAR,KULLANICI_HAKLARI`,
        { headers }
      );
      const result = await response.json();
      const fullUser = result.value?.[0];

      if (fullUser) {
        setSelectedUser({
          ID: fullUser.ID,
          AD_SOYAD: fullUser.AD_SOYAD || "",
          Mail_Adress: fullUser.Mail_Adress || "",
          CEP_NO: fullUser.CEP_NO || "",
          // DB'den "Aktif"/"Pasif" STRING gelir; switch ve kaydetme mantığı boolean bekliyor.
          // Normalize edilmezse `"Pasif" ? "Aktif" : "Pasif"` her zaman "Aktif" üretip
          // dondurulmuş hesapları her kayıtta sessizce yeniden aktifleştiriyordu.
          AKTIF_DURUM: String(fullUser.AKTIF_DURUM || "").toLowerCase() === "aktif",
          Password: "",

          Address_ID: fullUser.KULLANICI_ADRESLERI?.[0]?.ID,
          City: fullUser.KULLANICI_ADRESLERI?.[0]?.IL || "",
          District: fullUser.KULLANICI_ADRESLERI?.[0]?.ILCE || "",
          AddressText: fullUser.KULLANICI_ADRESLERI?.[0]?.ACIK_ADRES || "",

          Company_ID: fullUser.MAGAZALAR?.[0]?.ID,
          Company_Name: fullUser.MAGAZALAR?.[0]?.MAGAZA_ADI || "",

          Invoice_ID: fullUser.FATURA_BILGILERI?.[0]?.ID,
          Bank_ID: fullUser.FATURA_BILGILERI?.[0]?.ID,
          Tax_No: fullUser.FATURA_BILGILERI?.[0]?.VERGI_NO || "",
          Tax_Office: fullUser.FATURA_BILGILERI?.[0]?.VERGI_DAIRESI || "",
          IBAN: fullUser.FATURA_BILGILERI?.[0]?.IBAN || "",
          Bank_Name: fullUser.FATURA_BILGILERI?.[0]?.BANKA_ADI || "",

          Haklar_ID: fullUser.KULLANICI_HAKLARI?.[0]?.ID || null,
          ILAN_HAKKI: fullUser.KULLANICI_HAKLARI?.[0]?.ILAN_HAKKI ?? 2,
          MEZAT_HAKKI: fullUser.KULLANICI_HAKLARI?.[0]?.MEZAT_HAKKI ?? 0,
          DEGERLEME_HAKKI: fullUser.KULLANICI_HAKLARI?.[0]?.DEGERLEME_HAKKI ?? 0
        });
      }
    } catch (error) {
      toast.error("Düzenlenecek profil detayları yüklenemedi.");
      setEditModal(false);
    } finally {
      setIsDetailsLoading(false);
    }
  };


  // --- GÖRÜNTÜLEME MODALI AÇILIŞI ---
  const handleViewProfile = async (user) => {
    setViewModal(true);
    setIsDetailsLoading(true);
    setActiveViewTab("1");
    try {
      const response = await fetch(
        `${BASE_URL}/KULLANICILAR?$filter=ID eq ${user.ID}&$expand=KULLANICI_ADRESLERI,KULLANICI_SERTIFIKALARI,FATURA_BILGILERI,MAGAZALAR,KULLANICI_HAKLARI`
      );
      const result = await response.json();
      if (result.value && result.value.length > 0) setDetailedUser(result.value[0]);
    } catch (error) {
      toast.error("Profil detayları yüklenemedi.");
    } finally {
      setIsDetailsLoading(false);
    }
  };

  const handleDeleteProfile = async (id) => {
    // Yanlışlıkla tıklamaları önlemek için kullanıcıdan onay alıyoruz
    if (!window.confirm("Bu kullanıcıyı kalıcı olarak silmek istediğinize emin misiniz? (Dikkat: Eğer kullanıcının geçmiş siparişleri veya ilanları varsa veritabanı silmeye izin vermeyebilir.)")) {
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/KULLANICILAR(${id})`, {
        method: "DELETE",
        headers: headers // Yukarıda tanımladığımız yetki token'ı
      });

      if (response.ok) {
        toast.success("Kullanıcı başarıyla silindi.");
        fetchUsers(); // Tabloyu yenilemek için listeyi tekrar çekiyoruz
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error("Silme Hatası:", errorData);
        toast.error("Kullanıcı silinemedi! Kullanıcıya bağlı alt veriler (ilan, fatura, mesaj vb.) olabilir.");
      }
    } catch (error) {
      console.error("Silme Hatası:", error);
      toast.error("Silme işlemi sırasında sunucuyla iletişim kurulamadı.");
    }
  };
  
  // --- KAYDET / GÜNCELLE (ADD & EDIT ORTAK FONKSİYON) ---
  const handleSaveSubmit = async () => {
    if (!selectedUser) return;
    if (!selectedUser.AD_SOYAD || !selectedUser.Mail_Adress) {
        toast.warning("Lütfen zorunlu alanları (Ad Soyad, E-posta) doldurunuz.");
        return;
    }
    
    setIsSaving(true);
    try {
      let uid = selectedUser.ID;

  // 1. ANA KULLANICI İŞLEMİ (Ekle veya Güncelle)
      if (isAddMode) {
        // SQL Tablosuna birebir uygun payload
        if (!selectedUser.Password || selectedUser.Password.length < 8) {
            setIsSaving(false);
            toast.warning("Lütfen en az 8 karakterlik bir şifre belirleyiniz.");
            return;
        }

        const userPayload = {
          AD_SOYAD: selectedUser.AD_SOYAD,
          Mail_Adress: selectedUser.Mail_Adress,

          // Şifreyi DB'deki adıyla gönderiyoruz (backend hash'leyecek):
          Hash_Sifre: selectedUser.Password,

          // Sistemde AKTIF_DURUM "Aktif" / "Pasif" / "Beklemede" string değerlerini alır.
          AKTIF_DURUM: selectedUser.AKTIF_DURUM ? "Aktif" : "Pasif",

          // DB'de NOT NULL tanımlı olduğu için boş bırakmıyoruz:
          HESAP_TURU: "Kullanici",

          // Yeni kullanıcılar satış onayında beklesin (mobil kayıt ile tutarlı).
          SATIS_ONAY_DURUMU: "Beklemede",

        };

        // Eğer CEP_NO boşsa hiç göndermiyoruz, doluysa string olarak yolluyoruz.
        if (selectedUser.CEP_NO && selectedUser.CEP_NO.trim() !== "") {
            userPayload.CEP_NO = selectedUser.CEP_NO;
        }

        console.log("Backend'e Gönderilen SQL Uyumlu Payload:", userPayload);

        const userRes = await fetch(`${BASE_URL}/KULLANICILAR`, {
          method: "POST", 
          headers: headers,
          body: JSON.stringify(userPayload),
        });
        
        const newUser = await userRes.json();
        
        if (!userRes.ok) {
            console.error("Backend Error Details:", newUser);
            throw new Error("Kullanıcı oluşturulamadı. Lütfen konsolu kontrol edin.");
        }
        uid = newUser.ID || newUser.id || newUser.value?.[0]?.ID;
      }

     else { // Güncelleme Modu
        const putPayload = {
          AD_SOYAD: selectedUser.AD_SOYAD,
          Mail_Adress: selectedUser.Mail_Adress,
          AKTIF_DURUM: selectedUser.AKTIF_DURUM ? "Aktif" : "Pasif"
        };
        
        if (selectedUser.CEP_NO && selectedUser.CEP_NO.trim() !== "") {
            putPayload.CEP_NO = selectedUser.CEP_NO;
        }

        // Eğer yeni şifre girildiyse ekle (backend hash'leyecek)
        if (selectedUser.Password && selectedUser.Password.trim() !== "" && selectedUser.Password.length >= 8) {
            putPayload.Hash_Sifre = selectedUser.Password;
        } else if (selectedUser.Password && selectedUser.Password.length < 8) {
            setIsSaving(false);
            toast.warning("Şifre en az 8 karakter olmalıdır.");
            return;
        }

        const putRes = await fetch(`${BASE_URL}/KULLANICILAR(${uid})`, {
          method: "PUT",
          headers: headers,
          body: JSON.stringify(putPayload),
        });

        // Yanıt kontrol edilmediği için backend 500 dönse bile ekranda
        // "güncellendi" yazıyordu; şifre değişmediği halde başarı görünüyordu.
        if (!putRes.ok) {
          const errBody = await putRes.json().catch(() => ({}));
          console.error("Kullanıcı güncelleme hatası:", putRes.status, errBody);
          throw new Error(
            errBody.detail || errBody.message || `Kullanıcı güncellenemedi (HTTP ${putRes.status}).`
          );
        }
      }

      // Diğer tablolara atılacak istekleri toplayacağımız dizi
      const extraPromises = [];

      // 2. ADRES GÜNCELLEMESİ / EKLENMESİ
      if (selectedUser.City || selectedUser.District || selectedUser.AddressText) {
        const addressPayload = { KULLANICI_ID: uid, IL: selectedUser.City, ILCE: selectedUser.District, ACIK_ADRES: selectedUser.AddressText };
        if (selectedUser.Address_ID && !isAddMode) {
            extraPromises.push(fetch(`${BASE_URL}/KULLANICI_ADRESLERI(${selectedUser.Address_ID})`, { method: "PATCH", headers: headers, body: JSON.stringify(addressPayload) }));
        } else {
            extraPromises.push(fetch(`${BASE_URL}/KULLANICI_ADRESLERI`, { method: "POST", headers: headers, body: JSON.stringify(addressPayload) }));
        }
      }

      // 3. FATURA / BANKA GÜNCELLEMESİ / EKLENMESİ
      if (selectedUser.IBAN || selectedUser.Bank_Name || selectedUser.Tax_No || selectedUser.Tax_Office) {
        const bankPayload = { KULLANICI_ID: uid, IBAN: selectedUser.IBAN, BANKA_ADI: selectedUser.Bank_Name, VERGI_NO: selectedUser.Tax_No, VERGI_DAIRESI: selectedUser.Tax_Office };
        if (selectedUser.Bank_ID && !isAddMode) {
            extraPromises.push(fetch(`${BASE_URL}/FATURA_BILGILERI(${selectedUser.Bank_ID})`, { method: "PATCH", headers: headers, body: JSON.stringify(bankPayload) }));
        } else {
            extraPromises.push(fetch(`${BASE_URL}/FATURA_BILGILERI`, { method: "POST", headers: headers, body: JSON.stringify(bankPayload) }));
        }
      }

      // 4. MAĞAZA GÜNCELLEMESİ / EKLENMESİ
      if (selectedUser.Company_Name) {
        if (selectedUser.Company_ID && !isAddMode) {
            extraPromises.push(fetch(`${BASE_URL}/MAGAZALAR(${selectedUser.Company_ID})`, { method: "PATCH", headers: headers, body: JSON.stringify({ MAGAZA_ADI: selectedUser.Company_Name }) }));
        } else {
            extraPromises.push(fetch(`${BASE_URL}/MAGAZALAR`, { method: "POST", headers: headers, body: JSON.stringify({ KULLANICI_ID: uid, MAGAZA_ADI: selectedUser.Company_Name, OLUSTURMA_TARIHI: new Date().toISOString() }) }));
        }
      }

      // 5. KULLANICI_HAKLARI GÜNCELLEMESİ / EKLENMESİ
      const haklarPayload = {
        KULLANICI_ID: uid,
        ILAN_HAKKI: Number(selectedUser.ILAN_HAKKI),
        MEZAT_HAKKI: Number(selectedUser.MEZAT_HAKKI),
        DEGERLEME_HAKKI: Number(selectedUser.DEGERLEME_HAKKI),
      };
      if (selectedUser.Haklar_ID && !isAddMode) {
        extraPromises.push(fetch(`${BASE_URL}/KULLANICI_HAKLARI(${selectedUser.Haklar_ID})`, { method: "PATCH", headers: headers, body: JSON.stringify(haklarPayload) }));
      } else {
        extraPromises.push(fetch(`${BASE_URL}/KULLANICI_HAKLARI`, { method: "POST", headers: headers, body: JSON.stringify(haklarPayload) }));
      }

      // Paralel istekleri beklet
      await Promise.all(extraPromises);

      toast.success(isAddMode ? "Kullanıcı başarıyla eklendi." : "Kullanıcının tüm bilgileri başarıyla güncellendi.");
      setEditModal(false);
      fetchUsers(); // Tabloyu yenile

    } catch (error) {
      console.error("Kayıt Hatası:", error);
      toast.error(error?.message || "Kayıt sırasında bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleChange = (field, value) => {
    setSelectedUser(prev => ({ ...prev, [field]: value }));
  };

  // ─── FİLTRE / İSTATİSTİK MANTIĞI ─────────────────────────────
  // Türkçe-duyarsız arama normalizasyonu.
  const normTR = (s) =>
    String(s || "").toLocaleLowerCase("tr-TR").replace(/ı/g, "i").replace(/i̇/g, "i");

  // Hızlı aralık seçimi manuel tarihleri ezerek etkin başlangıç/bitiş üretir.
  const effectiveRange = useMemo(() => {
    const now = new Date();
    const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
    const endOfDay = (d) => { const x = new Date(d); x.setHours(23, 59, 59, 999); return x; };

    if (datePreset === "today") return { start: startOfDay(now), end: endOfDay(now) };
    if (datePreset === "7days") { const s = new Date(now); s.setDate(s.getDate() - 6); return { start: startOfDay(s), end: endOfDay(now) }; }
    if (datePreset === "30days") { const s = new Date(now); s.setDate(s.getDate() - 29); return { start: startOfDay(s), end: endOfDay(now) }; }
    if (datePreset === "thismonth") return { start: startOfDay(new Date(now.getFullYear(), now.getMonth(), 1)), end: endOfDay(now) };

    // Manuel aralık
    return {
      start: dateStart ? startOfDay(new Date(dateStart)) : null,
      end: dateEnd ? endOfDay(new Date(dateEnd)) : null,
    };
  }, [datePreset, dateStart, dateEnd]);

  const filteredUsers = useMemo(() => {
    const q = normTR(searchQuery).trim();
    return (users || []).filter((u) => {
      // Rol
      if (filterRol !== "all" && (u.HESAP_TURU || "") !== filterRol) return false;
      // Durum
      if (filterDurum !== "all" && (u.AKTIF_DURUM || "").toLowerCase() !== filterDurum.toLowerCase()) return false;
      // Giriş yöntemi
      if (filterGiris !== "all") {
        const baglar = sosyalHaritasi[u.ID] || [];
        if (filterGiris === "telefon" ? baglar.length > 0 : !baglar.some((b) => b.SAGLAYICI === filterGiris)) return false;
      }
      // Tarih aralığı
      if (effectiveRange.start || effectiveRange.end) {
        if (!u.OLUSTURMA_TARIHI) return false;
        const d = new Date(u.OLUSTURMA_TARIHI);
        if (effectiveRange.start && d < effectiveRange.start) return false;
        if (effectiveRange.end && d > effectiveRange.end) return false;
      }
      // Arama (ad, e-posta, telefon, ID)
      if (q) {
        return (
          normTR(u.AD_SOYAD).includes(q) ||
          normTR(u.Mail_Adress).includes(q) ||
          normTR(u.CEP_NO).includes(q) ||
          String(u.ID).includes(q)
        );
      }
      return true;
    });
  }, [users, searchQuery, filterRol, filterDurum, filterGiris, sosyalHaritasi, effectiveRange]);

  const userStats = useMemo(() => {
    const now = new Date();
    const isSameDay = (d) => d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    const isSameMonth = (d) => d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    let aktif = 0, pasif = 0, bugun = 0, buAy = 0;
    (users || []).forEach((u) => {
      const durum = (u.AKTIF_DURUM || "").toLowerCase();
      if (durum === "aktif") aktif++;
      else if (durum === "pasif") pasif++;
      if (u.OLUSTURMA_TARIHI) {
        const d = new Date(u.OLUSTURMA_TARIHI);
        if (isSameDay(d)) bugun++;
        if (isSameMonth(d)) buAy++;
      }
    });
    return { total: users?.length || 0, aktif, pasif, bugun, buAy };
  }, [users]);

  // Rol seçenekleri (mevcut veriden türetilir).
  const rolSecenekleri = useMemo(
    () => [...new Set((users || []).map((u) => u.HESAP_TURU).filter(Boolean))].sort(),
    [users]
  );

  const resetFilters = () => {
    setSearchQuery("");
    setFilterRol("all");
    setFilterDurum("all");
    setFilterGiris("all");
    setDateStart("");
    setDateEnd("");
    setDatePreset("all");
  };

  const hasActiveFilter =
    searchQuery || filterRol !== "all" || filterDurum !== "all" || filterGiris !== "all" ||
    dateStart || dateEnd || datePreset !== "all";

  // ─── TOPLU SEÇİM ─────────────────────────────────────────────
  const secimDegistir = (id) =>
    setSeciliIdler((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));

  // Başlık kutusu yalnızca FİLTRELENMİŞ listeyi kapsar; filtre değişince
  // görünmeyen kullanıcılar seçili kalmasın diye seçim de filtreye göre kırpılır.
  const tumunuSec = (isaretli) =>
    setSeciliIdler(isaretli ? filteredUsers.map((u) => u.ID) : []);

  const tumSecili =
    filteredUsers.length > 0 && filteredUsers.every((u) => seciliIdler.includes(u.ID));

  const seciliKullanicilar = useMemo(
    () => (users || []).filter((u) => seciliIdler.includes(u.ID)),
    [users, seciliIdler]
  );

 const columns = useMemo(() => [
    {
      // Toplu hak verme için çoklu seçim. Başlıktaki kutu, o an FİLTRELENMİŞ
      // listenin tamamını seçer (tüm veritabanını değil) — yanlışlıkla binlerce
      // kullanıcıya işlem yapılmasın diye. "Tüm kullanıcılar" senaryosu toplu
      // modal içindeki ayrı onay kutusuyla yapılır.
      id: "secim",
      header: () => (
        <Input
          type="checkbox"
          className="form-check-input m-0"
          checked={tumSecili}
          onChange={(e) => tumunuSec(e.target.checked)}
        />
      ),
      enableSorting: false,
      cell: (c) => {
        const u = c.row.original;
        return (
          <Input
            type="checkbox"
            className="form-check-input m-0"
            checked={seciliIdler.includes(u.ID)}
            onChange={() => secimDegistir(u.ID)}
          />
        );
      },
    },
    { header: "ID", accessorKey: "ID", cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "Ad Soyad",
      accessorKey: "AD_SOYAD",
      cell: (c) => (
        <div className="d-flex align-items-center">
          <div className="avatar-xs me-2">
            <span className="avatar-title rounded-circle bg-primary-subtle text-primary">{c.getValue()?.charAt(0)}</span>
          </div>
          {c.getValue()}
        </div>
      ),
    },
    { header: "E-posta", accessorKey: "Mail_Adress" },
    { header: "Telefon", accessorKey: "CEP_NO", cell: (c) => c.getValue() || <span className="text-muted">—</span> },
    { header: "Rol", accessorKey: "HESAP_TURU", cell: (c) => <Badge color="info" pill>{c.getValue() || "—"}</Badge> },
    {
      header: "Giriş",
      id: "giris_yontemi",
      enableSorting: false,
      cell: (c) => {
        const baglar = sosyalHaritasi[c.row.original.ID] || [];
        if (!baglar.length) return <span className="text-muted font-size-12">Telefon</span>;
        return (
          <span className="d-inline-flex gap-1">
            {baglar.map((b) => {
              const bilgi = SAGLAYICI_BILGI[b.SAGLAYICI] || { ad: b.SAGLAYICI, ikon: "bx bx-link", renk: "#6c757d" };
              return <i key={b.ID} className={`${bilgi.ikon} font-size-18`} style={{ color: bilgi.renk }} title={`${bilgi.ad}${b.EPOSTA ? ` — ${b.EPOSTA}` : ""}`} />;
            })}
          </span>
        );
      },
    },
    {
      header: "Üyelik Tarihi",
      accessorKey: "OLUSTURMA_TARIHI",
      cell: (c) => {
        const v = c.getValue();
        if (!v) return <span className="text-muted">—</span>;
        const d = new Date(v);
        return (
          <div className="font-size-13">
            <div>{d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" })}</div>
            <div className="text-muted font-size-11">
              <i className="bx bx-time-five me-1" />
              {d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}
            </div>
          </div>
        );
      },
    },
    {
      header: "Durum",
      accessorKey: "AKTIF_DURUM",
      cell: (c) => {
        const v = (c.getValue() || "").toLowerCase();
        return <Badge color={v === "aktif" ? "success" : v === "pasif" ? "danger" : "warning"}>{c.getValue() || "?"}</Badge>;
      }
    },
    {
      header: "2FA",
      accessorKey: "IsTwoFactorEnabled",
      cell: (cellProps) => {
        const user = cellProps.row.original;
        const enabled = user.IsTwoFactorEnabled === true;
        const handleToggle2FA = async (next) => {
          const action = next ? "açmak" : "kapatmak";
          if (!window.confirm(`Bu kullanıcı için iki adımlı doğrulamayı ${action} istediğinize emin misiniz?`)) return;
          try {
            const res = await fetch(`${BASE_URL}/KULLANICILAR(${user.ID})`, {
              method: "PATCH",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ IsTwoFactorEnabled: next }),
            });
            if (res.ok) fetchUsers();
            else alert("Güncelleme başarısız.");
          } catch (e) { alert("Bağlantı hatası."); }
        };
        return (
          <div className="d-flex align-items-center gap-2">
            <Badge color={enabled ? "success" : "secondary"} pill>
              <i className={`bx ${enabled ? "bx-shield-quarter" : "bx-shield-x"} me-1`} />
              {enabled ? "Açık" : "Kapalı"}
            </Badge>
            <Button
              color={enabled ? "warning" : "success"}
              outline
              size="sm"
              onClick={() => handleToggle2FA(!enabled)}
              id={`twofa-${user.ID}`}
            >
              <i className={`bx ${enabled ? "bx-power-off" : "bx-check-shield"}`} />
            </Button>
            <UncontrolledTooltip target={`twofa-${user.ID}`}>
              {enabled ? "2FA'yı sıfırla / kapat" : "2FA'yı zorla aç"}
            </UncontrolledTooltip>
          </div>
        );
      }
    },
 {
      header: "Aksiyon",
      cell: (cellProps) => {
        const user = cellProps.row.original;
        return (
          <div className="d-flex gap-3">
            <Button color="link" className="p-0 text-success" onClick={() => handleEditProfile(user)}>
              <i className="mdi mdi-pencil font-size-18" id={`edit-${user.ID}`} />
            </Button>

            <Button color="link" className="p-0 text-primary" onClick={() => handleViewProfile(user)}>
              <i className="mdi mdi-eye font-size-18" id={`view-${user.ID}`} />
            </Button>

            <Link to={`/kullanici-aktiviteleri/${user.ID}`} className="p-0 text-warning border-0 bg-transparent">
              <i className="mdi mdi-clipboard-list-outline font-size-18" id={`history-${user.ID}`} />
            </Link>

            {/* Kategori bazlı hak ver — Kategori Bazlı Haklar sayfasına gitmeden */}
            <Button color="link" className="p-0 text-info" onClick={() => openHakModal(user)}>
              <i className="mdi mdi-key-variant font-size-18" id={`hak-${user.ID}`} />
            </Button>

            {/* Ekstra/kozmetik haklar (vitrin, moderatör, mezat deneme) + hak geçmişi */}
            <Button color="link" className="p-0 text-warning" onClick={() => openKozmetikModal(user)}>
              <i className="mdi mdi-star-circle-outline font-size-18" id={`kozmetik-${user.ID}`} />
            </Button>

            {/* YENİ EKLENEN SİLME BUTONU */}
            <Button color="link" className="p-0 text-danger" onClick={() => handleDeleteProfile(user.ID)}>
              <i className="mdi mdi-trash-can font-size-18" id={`delete-${user.ID}`} />
            </Button>

            <UncontrolledTooltip target={`edit-${user.ID}`}>Tüm Bilgileri Düzenle</UncontrolledTooltip>
            <UncontrolledTooltip target={`view-${user.ID}`}>Kişisel Profili Gör</UncontrolledTooltip>
            <UncontrolledTooltip target={`history-${user.ID}`}>Sistem Aktiviteleri (İşler/Teklifler)</UncontrolledTooltip>
            <UncontrolledTooltip target={`hak-${user.ID}`}>Kategori Bazlı Hak Ver</UncontrolledTooltip>
            <UncontrolledTooltip target={`kozmetik-${user.ID}`}>Ekstra Haklar & Hak Geçmişi</UncontrolledTooltip>
            <UncontrolledTooltip target={`delete-${user.ID}`}>Kullanıcıyı Sil</UncontrolledTooltip>
          </div>
        );
      }
    }

    // seciliIdler/tumSecili değişince onay kutuları yeniden çizilmeli
  ], [seciliIdler, tumSecili, filteredUsers, sosyalHaritasi]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı Listesi" />

          {/* ── TOPLU İŞLEM ÇUBUĞU ──────────────────────────────
              Yalnızca seçim yapılınca görünür; boşken arayüzü kalabalıklaştırmaz.
              "Tüm aktif kullanıcılar" senaryosu modalin içindeki ayrı onay
              kutusuyla yapılır, buradan değil. */}
          {seciliIdler.length > 0 && (
            <Card className="mb-3 border-primary">
              <CardBody className="py-2 px-3 d-flex align-items-center flex-wrap gap-2">
                <Badge color="primary" pill className="fs-6">{seciliIdler.length}</Badge>
                <span className="fw-medium">kullanıcı seçildi</span>
                <Button color="primary" size="sm" className="ms-2"
                  onClick={() => setTopluModal(true)}>
                  <i className="mdi mdi-account-multiple-plus-outline me-1" />
                  Toplu Hak Ver
                </Button>
                <Button color="link" size="sm" className="text-muted"
                  onClick={() => setSeciliIdler([])}>
                  Seçimi temizle
                </Button>
              </CardBody>
            </Card>
          )}

          {/* ── İSTATİSTİK KARTLARI ─────────────────────────────── */}
          <Row className="mb-3">
            {[
              { label: "Toplam Kullanıcı", value: userStats.total, icon: "bx-group", color: "primary" },
              { label: "Aktif", value: userStats.aktif, icon: "bx-user-check", color: "success" },
              { label: "Pasif", value: userStats.pasif, icon: "bx-user-x", color: "danger" },
              { label: "Bugün Üye Olan", value: userStats.bugun, icon: "bx-user-plus", color: "info" },
              { label: "Bu Ay Üye Olan", value: userStats.buAy, icon: "bx-calendar-star", color: "warning" },
            ].map((s, i) => (
              <Col key={i} xs={6} md={4} xl={2} className="mb-2">
                <Card className="mini-stats-wid mb-0 h-100">
                  <CardBody className="py-3 px-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 overflow-hidden">
                        <p className="text-muted fw-medium mb-1 font-size-12 text-truncate">{s.label}</p>
                        <h4 className="mb-0">
                          {isLoading ? <Spinner size="sm" color={s.color} /> : s.value}
                        </h4>
                      </div>
                      <div className={`avatar-sm rounded-circle bg-${s.color} align-self-center ms-2`}>
                        <span className={`avatar-title rounded-circle bg-${s.color}`}>
                          <i className={`bx ${s.icon} font-size-20`} />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-3">
                 <div>
                   <h4 className="card-title mb-1">Sistem Kullanıcıları</h4>
                   <p className="text-muted mb-0 font-size-13">
                     {filteredUsers.length} / {users.length} kullanıcı listeleniyor
                   </p>
                 </div>
                 <Button color="primary" onClick={handleAddProfile}>
                    <i className="bx bx-plus font-size-16 align-middle me-2"></i> Yeni Kullanıcı Ekle
                 </Button>
              </div>

              {/* ── FİLTRELER ─────────────────────────────────────── */}
              <Row className="g-2 mb-3 align-items-end">
                <Col md={3}>
                  <Label className="form-label mb-1 font-size-12 text-muted">Ara</Label>
                  <Input
                    type="search" bsSize="sm"
                    placeholder="Ad, e-posta, telefon, ID..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Label className="form-label mb-1 font-size-12 text-muted">Rol</Label>
                  <Input type="select" bsSize="sm" value={filterRol} onChange={(e) => setFilterRol(e.target.value)}>
                    <option value="all">Tüm Roller</option>
                    {rolSecenekleri.map((r) => <option key={r} value={r}>{r}</option>)}
                  </Input>
                </Col>
                <Col md={2}>
                  <Label className="form-label mb-1 font-size-12 text-muted">Durum</Label>
                  <Input type="select" bsSize="sm" value={filterDurum} onChange={(e) => setFilterDurum(e.target.value)}>
                    <option value="all">Tüm Durumlar</option>
                    <option value="Aktif">Aktif</option>
                    <option value="Pasif">Pasif</option>
                    <option value="Beklemede">Beklemede</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label className="form-label mb-1 font-size-12 text-muted">Giriş Yöntemi</Label>
                  <Input type="select" bsSize="sm" value={filterGiris} onChange={(e) => setFilterGiris(e.target.value)}>
                    <option value="all">Tümü</option>
                    <option value="google">Google</option>
                    <option value="apple">Apple</option>
                    <option value="facebook">Facebook</option>
                    <option value="telefon">Yalnız telefon/şifre</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label className="form-label mb-1 font-size-12 text-muted">Hızlı Aralık</Label>
                  <Input
                    type="select" bsSize="sm" value={datePreset}
                    onChange={(e) => { setDatePreset(e.target.value); if (e.target.value !== "all") { setDateStart(""); setDateEnd(""); } }}
                  >
                    <option value="all">Tümü</option>
                    <option value="today">Bugün</option>
                    <option value="7days">Son 7 Gün</option>
                    <option value="30days">Son 30 Gün</option>
                    <option value="thismonth">Bu Ay</option>
                  </Input>
                </Col>
                <Col md={3}>
                  <Label className="form-label mb-1 font-size-12 text-muted">Kayıt Tarihi Aralığı</Label>
                  <div className="d-flex gap-1">
                    <Input
                      type="date" bsSize="sm" value={dateStart}
                      onChange={(e) => { setDateStart(e.target.value); setDatePreset("all"); }}
                      title="Başlangıç"
                    />
                    <Input
                      type="date" bsSize="sm" value={dateEnd}
                      onChange={(e) => { setDateEnd(e.target.value); setDatePreset("all"); }}
                      title="Bitiş"
                    />
                  </div>
                </Col>
                {hasActiveFilter && (
                  <Col xs={12}>
                    <Button color="light" size="sm" className="border" onClick={resetFilters}>
                      <i className="bx bx-x me-1" />Filtreleri Temizle
                    </Button>
                  </Col>
                )}
              </Row>

              {isLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : (
             <TableContainer
                columns={columns}
                data={filteredUsers || []}
                isGlobalFilter={false}
                isPagination={true}
                customPageSize={filteredUsers.length < 10 ? (filteredUsers.length || 1) : 10}
                SearchPlaceholder="Kullanıcı ara..."
                tableClass="align-middle table-nowrap table-hover"
                theadClass="table-light"
                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                pagination="pagination pagination-rounded justify-content-end mb-2"
              />
              )}
            </CardBody>
          </Card>
        </Container>

        {/* ========================================================================= */}
        {/* --- MODAL: KULLANICI EKLE / DÜZENLE --- */}
        {/* ========================================================================= */}
        <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered size="lg">
          <ModalHeader toggle={() => setEditModal(false)} className="bg-light">
            <i className={`mdi ${isAddMode ? 'mdi-account-plus' : 'mdi-account-edit'} text-success me-2`}></i> 
            {isAddMode ? "Yeni Kullanıcı Ekle" : `Kullanıcıyı Düzenle (#${selectedUser?.ID})`}
          </ModalHeader>
          <ModalBody className="p-0">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="success" /></div> : selectedUser && (
              <div className="bg-light-subtle pb-3">
               <Nav tabs className="nav-tabs-custom nav-justified bg-white pt-2">
  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "1" })} onClick={() => setActiveEditTab("1")} style={{cursor:'pointer'}}>Genel Bilgiler</NavLink></NavItem>
  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "2" })} onClick={() => setActiveEditTab("2")} style={{cursor:'pointer'}}>Adres</NavLink></NavItem>
  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "4" })} onClick={() => setActiveEditTab("4")} style={{cursor:'pointer'}}>Şirket & Finans</NavLink></NavItem>
  <NavItem><NavLink className={classnames("fw-bold", { active: activeEditTab === "5" })} onClick={() => setActiveEditTab("5")} style={{cursor:'pointer'}}>Sistem Hakları</NavLink></NavItem>
</Nav>

                <TabContent activeTab={activeEditTab} className="p-4">
                  {/* DÜZENLE/EKLE: GENEL BİLGİLER */}
                  <TabPane tabId="1">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ad Soyad <span className="text-danger">*</span></Label>
                            <Input type="text" value={selectedUser.AD_SOYAD} onChange={(e) => handleChange("AD_SOYAD", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">E-posta Adresi <span className="text-danger">*</span></Label>
                            <Input type="email" value={selectedUser.Mail_Adress} onChange={(e) => handleChange("Mail_Adress", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Telefon Numarası</Label>
                            <Input type="text" value={selectedUser.CEP_NO} onChange={(e) => handleChange("CEP_NO", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold d-block">Sistem Durumu</Label>
                            <div className="form-check form-switch form-switch-lg mb-3" dir="ltr">
                                <Input type="checkbox" className="form-check-input" checked={selectedUser.AKTIF_DURUM} onChange={(e) => handleChange("AKTIF_DURUM", e.target.checked)} />
                                <Label className="form-check-label fw-medium ms-2 mt-1">
                                {selectedUser.AKTIF_DURUM ? <span className="text-success">Aktif Kullanıcı</span> : <span className="text-danger">Hesap Dondurulmuş</span>}
                                </Label>
                            </div>
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">{isAddMode ? "Şifre" : "Yeni Şifre (Boş bırakılırsa değişmez)"} {isAddMode && <span className="text-danger">*</span>}</Label>
                            <InputGroup>
                              <Input type={showPassword ? "text" : "password"} value={selectedUser.Password || ""} onChange={(e) => handleChange("Password", e.target.value)} placeholder={isAddMode ? "En az 8 karakter" : "Değiştirmek için doldurun"} />
                              <Button color="light" outline onClick={() => setShowPassword(v => !v)} type="button">
                                <i className={`bx ${showPassword ? "bx-hide" : "bx-show"}`} />
                              </Button>
                            </InputGroup>
                            {!isAddMode && (
                              <small className="text-muted d-block mt-1">
                                <i className="bx bx-lock-alt me-1" />
                                Mevcut şifre veritabanında geri döndürülemez şekilde (PBKDF2) saklandığı
                                için görüntülenemez; yalnızca yenisiyle değiştirilebilir.
                              </small>
                            )}
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE/EKLE: ADRES BİLGİLERİ */}
                  <TabPane tabId="2">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">İl / Şehir</Label>
                            <Input type="text" placeholder="Örn: İstanbul" value={selectedUser.City} onChange={(e) => handleChange("City", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">İlçe</Label>
                            <Input type="text" placeholder="Örn: Kadıköy" value={selectedUser.District} onChange={(e) => handleChange("District", e.target.value)} />
                        </Col>
                        <Col md={12}>
                            <Label className="fw-bold">Açık Adres</Label>
                            <Input type="textarea" rows="3" value={selectedUser.AddressText} onChange={(e) => handleChange("AddressText", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE/EKLE: EHLİYET BİLGİLERİ */}
                  <TabPane tabId="3">
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ehliyet Sınıfı</Label>
                            <Input type="text" placeholder="Örn: B, C, E" value={selectedUser.License_Class} onChange={(e) => handleChange("License_Class", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Ehliyet Numarası</Label>
                            <Input type="text" value={selectedUser.License_No} onChange={(e) => handleChange("License_No", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE/EKLE: SİSTEM HAKLARI */}
                  <TabPane tabId="5">
                    <div className="alert alert-info d-flex align-items-center mb-3" role="alert">
                      <i className="mdi mdi-information-outline me-2 font-size-18"></i>
                      <div>Bu alanda kullanıcının sistemdeki ilan, mezat ve değerleme haklarını yönetebilirsiniz. <strong>0</strong> = Hak yok, pozitif sayı = hak miktarı.</div>
                    </div>
                    <Row>
                      <Col md={4} className="mb-4">
                        <Label className="fw-bold">İlan Hakkı</Label>
                        <p className="text-muted small mb-1">Kullanıcının açabileceği ilan sayısı</p>
                        <Input
                          type="number" min="0"
                          value={selectedUser.ILAN_HAKKI}
                          onChange={(e) => handleChange("ILAN_HAKKI", e.target.value)}
                        />
                      </Col>
                      <Col md={4} className="mb-4">
                        <Label className="fw-bold">Mezat Hakkı</Label>
                        <p className="text-muted small mb-1">Kullanıcının katılabileceği mezat sayısı</p>
                        <Input
                          type="number" min="0"
                          value={selectedUser.MEZAT_HAKKI}
                          onChange={(e) => handleChange("MEZAT_HAKKI", e.target.value)}
                        />
                      </Col>
                      <Col md={4} className="mb-4">
                        <Label className="fw-bold">Değerleme Hakkı</Label>
                        <p className="text-muted small mb-1">Kullanıcının yapabileceği değerleme sayısı</p>
                        <Input
                          type="number" min="0"
                          value={selectedUser.DEGERLEME_HAKKI}
                          onChange={(e) => handleChange("DEGERLEME_HAKKI", e.target.value)}
                        />
                      </Col>
                    </Row>
                  </TabPane>

                  {/* DÜZENLE/EKLE: ŞİRKET & FİNANS */}
                  <TabPane tabId="4">
                    <h6 className="text-primary border-bottom pb-2 mb-3">Şirket ve Vergi Bilgileri</h6>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Label className="fw-bold">Şirket Adı / Ünvanı</Label>
                            <Input type="text" value={selectedUser.Company_Name} onChange={(e) => handleChange("Company_Name", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Vergi Numarası / T.C. No</Label>
                            <Input type="text" value={selectedUser.Tax_No} onChange={(e) => handleChange("Tax_No", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Vergi Dairesi</Label>
                            <Input type="text" value={selectedUser.Tax_Office} onChange={(e) => handleChange("Tax_Office", e.target.value)} />
                        </Col>
                    </Row>

                    <h6 className="text-primary border-bottom pb-2 my-3">Banka Hesabı</h6>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">Banka Adı</Label>
                            <Input type="text" placeholder="Örn: Garanti BBVA" value={selectedUser.Bank_Name} onChange={(e) => handleChange("Bank_Name", e.target.value)} />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="fw-bold">IBAN Numarası</Label>
                            <Input type="text" placeholder="TR..." value={selectedUser.IBAN} onChange={(e) => handleChange("IBAN", e.target.value)} />
                        </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            )}
          </ModalBody>
          <ModalFooter className="bg-light">
            <Button color="secondary" outline onClick={() => setEditModal(false)} disabled={isSaving}>İptal</Button>
            <Button color={isAddMode ? "primary" : "success"} onClick={handleSaveSubmit} disabled={isSaving || isDetailsLoading}>
              {isSaving ? <Spinner size="sm" className="me-2" /> : <i className={isAddMode ? "mdi mdi-plus me-1" : "mdi mdi-content-save me-1"}></i>}
              {isAddMode ? "Kullanıcıyı Ekle" : "Değişiklikleri Kaydet"}
            </Button>
          </ModalFooter>
        </Modal>

        {/* ========================================================================= */}
        {/* --- MODAL: PROFİL GÖR (SALT OKUNUR) --- */}
        {/* ========================================================================= */}
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} centered size="xl">
          <ModalHeader toggle={() => setViewModal(false)}>
            <i className="bx bx-user-circle me-2"></i> Kullanıcı Profili Detayı
          </ModalHeader>
          <ModalBody className="bg-light-subtle">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : detailedUser && (
              <>
                <Nav tabs className="nav-tabs-custom nav-justified mb-3 bg-white">
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "1" })} onClick={() => setActiveViewTab("1")} style={{cursor:'pointer'}}>Genel</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "2" })} onClick={() => setActiveViewTab("2")} style={{cursor:'pointer'}}>Ehliyet</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "3" })} onClick={() => setActiveViewTab("3")} style={{cursor:'pointer'}}>Şirket & Banka</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "4" })} onClick={() => setActiveViewTab("4")} style={{cursor:'pointer'}}>Belgeler</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeViewTab === "5" })} onClick={() => setActiveViewTab("5")} style={{cursor:'pointer'}}>Sistem Hakları</NavLink></NavItem>
                </Nav>

                <TabContent activeTab={activeViewTab}>
                  <TabPane tabId="1">
                    <Card><CardBody>
                      <Row>
                        <Col md={4} className="border-end">
                            <Label className="text-muted mb-0">Ad Soyad</Label><p className="fw-bold">{detailedUser.AD_SOYAD}</p>
                            <Label className="text-muted mb-0">E-posta</Label><p className="fw-bold">{detailedUser.Mail_Adress}</p>
                            <Label className="text-muted mb-0">Telefon</Label><p className="fw-bold">{detailedUser.CEP_NO || "---"}</p>
                            <Label className="text-muted mb-0">Üyelik Tarihi</Label><p className="fw-bold">{detailedUser.OLUSTURMA_TARIHI ? new Date(detailedUser.OLUSTURMA_TARIHI).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" }) : "---"}</p>
                            <Label className="text-muted mb-0">Bağlı Sosyal Hesaplar</Label>
                            {(sosyalHaritasi[detailedUser.ID] || []).length === 0 ? (
                              <p className="text-muted">Yok (telefon/şifre ile giriş)</p>
                            ) : (
                              <ul className="list-unstyled mb-2">
                                {(sosyalHaritasi[detailedUser.ID] || []).map((b) => {
                                  const bilgi = SAGLAYICI_BILGI[b.SAGLAYICI] || { ad: b.SAGLAYICI, ikon: "bx bx-link", renk: "#6c757d" };
                                  // Tarihler UTC ve Z'siz gelir.
                                  const son = b.SON_GIRIS_TARIHI ? new Date(String(b.SON_GIRIS_TARIHI).replace(/Z?$/, "Z")).toLocaleString("tr-TR") : null;
                                  return (
                                    <li key={b.ID} className="d-flex align-items-center gap-2 mb-1">
                                      <i className={`${bilgi.ikon} font-size-18`} style={{ color: bilgi.renk }} />
                                      <span className="fw-bold">{bilgi.ad}</span>
                                      {b.EPOSTA && <span className="text-muted font-size-12">{b.EPOSTA}</span>}
                                      {son && <span className="text-muted font-size-11">· son giriş {son}</span>}
                                      <Button size="sm" color="link" className="text-danger p-0 ms-auto" onClick={() => sosyalBaglantiKaldir(b)}>Kaldır</Button>
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                        </Col>
                        <Col md={8}>
                            <Label className="text-muted mb-0">Adres</Label>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_AdressText || "Bilgi Yok"}</p>
                            <p>{detailedUser.Users_Address?.[0]?.Users_Address_City} / {detailedUser.Users_Address?.[0]?.Users_Address_Dist}</p>
                        </Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="2">
                    <Card><CardBody>
                      <Row>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Sınıfı</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Class || "---"}</p></Col>
                        <Col md={6}><Label className="text-muted mb-0">Ehliyet Numarası</Label><p className="fw-bold">{detailedUser.Users_Driving_License?.[0]?.Driving_License_Number || "---"}</p></Col>
                      </Row>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="3">
                    <Card><CardBody>
                      <h6 className="text-primary border-bottom pb-2">Şirket Bilgileri</h6>
                      <p><strong>Firma:</strong> {detailedUser.Users_Company?.[0]?.Users_Company_Name || "Kayıtlı Şirket Yok"}</p>
                      <p><strong>Vergi No:</strong> {detailedUser.Users_Company?.[0]?.Users_Invoince?.[0]?.KdvNumber || "---"}</p>
                      <p><strong>Vergi Dairesi:</strong> {detailedUser.Users_Company?.[0]?.Users_Invoince?.[0]?.VergiDairesi || "---"}</p>
                      <h6 className="text-primary border-bottom pb-2 mt-4">Banka Bilgileri</h6>
                      <p><strong>IBAN:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_Iban || "---"}</p>
                      <p><strong>Banka:</strong> {detailedUser.Users_BankAccount?.[0]?.Users_BankAccount_BankName || "---"}</p>
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="5">
                    <Card><CardBody>
                      <h6 className="text-primary border-bottom pb-2 mb-3">Sistem Erişim Hakları</h6>
                      {detailedUser.KULLANICI_HAKLARI?.length > 0 ? (
                        <Row>
                          <Col md={4}>
                            <div className="text-center p-3 border rounded">
                              <i className="mdi mdi-tag-multiple display-5 text-info"></i>
                              <h4 className="mt-2 mb-0">{detailedUser.KULLANICI_HAKLARI[0].ILAN_HAKKI ?? 2}</h4>
                              <p className="text-muted mb-0">İlan Hakkı</p>
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="text-center p-3 border rounded">
                              <i className="mdi mdi-gavel display-5 text-warning"></i>
                              <h4 className="mt-2 mb-0">{detailedUser.KULLANICI_HAKLARI[0].MEZAT_HAKKI ?? 0}</h4>
                              <p className="text-muted mb-0">Mezat Hakkı</p>
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="text-center p-3 border rounded">
                              <i className="mdi mdi-star-check display-5 text-success"></i>
                              <h4 className="mt-2 mb-0">{detailedUser.KULLANICI_HAKLARI[0].DEGERLEME_HAKKI ?? 0}</h4>
                              <p className="text-muted mb-0">Değerleme Hakkı</p>
                            </div>
                          </Col>
                          {detailedUser.KULLANICI_HAKLARI[0].SON_GUNCELLEME && (
                            <Col md={12} className="mt-3">
                              <small className="text-muted">
                                <i className="mdi mdi-clock-outline me-1"></i>
                                Son güncelleme: {new Date(detailedUser.KULLANICI_HAKLARI[0].SON_GUNCELLEME).toLocaleString("tr-TR")}
                              </small>
                            </Col>
                          )}
                        </Row>
                      ) : (
                        <p className="text-muted">Bu kullanıcı için henüz hak tanımı yapılmamış.</p>
                      )}
                    </CardBody></Card>
                  </TabPane>

                  <TabPane tabId="4">
                    <Row>
                        {[
                            { n: "Kimlik", u: detailedUser.Users_Document?.[0]?.Identity_Url },
                            { n: "Ehliyet", u: detailedUser.Users_Document?.[0]?.License_Url },
                            { n: "Sabıka Kaydı", u: detailedUser.Users_Document?.[0]?.Criminalrecord_Url },
                            { n: "Vergi Levhası", u: detailedUser.Users_Document?.[0]?.Taxplate_Url }
                        ].map((doc, i) => (
                            <Col md={3} key={i}>
                                <Card className="text-center border shadow-none">
                                    <CardBody>
                                        <i className="mdi mdi-file-pdf-outline display-4 text-danger"></i>
                                        <p className="mt-2 fw-medium">{doc.n}</p>
                                        {doc.u ? <a href={doc.u} target="_blank" rel="noreferrer" className="btn btn-sm btn-soft-primary w-100">Görüntüle</a> : <Badge color="light" className="w-100">Yüklenmemiş</Badge>}
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                  </TabPane>
                </TabContent>
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
      <HizliHakModal
        isOpen={hakModal}
        toggle={() => setHakModal(false)}
        user={hakUser}
        headers={headers}
        onSaved={(adet) => toast.success(`${adet} kategoride haklar güncellendi.`)}
      />

      <KozmetikHakModal
        isOpen={kozmetikModal}
        toggle={() => setKozmetikModal(false)}
        user={kozmetikUser}
        headers={headers}
        onSaved={(adet) => toast.success(`${adet} ekstra hak güncellendi.`)}
      />

      <TopluHakModal
        isOpen={topluModal}
        toggle={() => setTopluModal(false)}
        secilenKullanicilar={seciliKullanicilar}
        headers={headers}
        onDone={(sonuc) => {
          toast.success(sonuc?.mesaj || "Toplu işlem tamamlandı.");
          setSeciliIdler([]);
        }}
      />

      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default KullaniciListesi;